import React from 'react';
import DesktopWindowsRoundedIcon from '@mui/icons-material/DesktopWindowsRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import img1 from "../assets/images/prof.png";

const InnerHeader = () => {

    const location = useLocation();

    const getPageName = () => {
        switch (location.pathname) {
            case '/webapp':
                return 'Dashboard';
            case '/webapp/vendormaster':
                return 'Vendor Master';
            case '/vendor/productcatalog':
                return 'Product Catalog';
            case '/vendor/orders':
                return 'Orders';
            case '/vendor/settings':
                return 'Settings';
            case '/vendor/vendoruser':
                return 'Vendor User';
            case '/vendor/addProduct/:update_id':
                return 'Add Product';
            case '/vendor/addbrand':
                return 'Add Brand';
            case '/vendor/productstock':
                return 'Product Stock';
            case '/vendor/Breadcrumbs':
                return 'Breadcrumbs';
            default:
                return '';
        }
    };

    return (
        <div>
            <header className="main-header">
                <div className="container-fluid">
                    <div className="main-header-inner">
                        <div className="page-title">
                            <h1>{getPageName()}</h1>
                        </div>
                        <div className="main-header-toolbar">
                            <div className="header-action">
                                <div className="header-action__item">
                                    <Link className="link"><DesktopWindowsRoundedIcon style={{ fontSize: "17px" }} /></Link>
                                </div>
                                <div className="header-action__item">
                                    <Link className="link"><SearchRoundedIcon style={{ fontSize: "17px" }} /></Link>
                                </div>
                                <div className="header-action__item">
                                    <Link className="link"><StorefrontOutlinedIcon style={{ fontSize: "17px" }} /></Link>
                                </div>
                                <div className="header-action__item">
                                    <Link className="link"><NotificationsActiveTwoToneIcon style={{ fontSize: "17px" }} /></Link>
                                </div>

                                <div className="header-action__item header-acc">
                                    <span className="header-account__img"><Link className="link"><img src={img1} alt="" /></Link></span>
                                </div>
                            </div>

                            {/* Shipping Details link */}
                            {location.pathname === '/vendor/orders' && (
                                <div className="header-action__item">
                                    <Link to="/vendor/shipping" className="link">
                                        Shipping Details
                                    </Link>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
};

export default InnerHeader;
